import { render, staticRenderFns } from "./example-day.vue?vue&type=template&id=350abec2&scoped=true&"
import script from "./example-day.vue?vue&type=script&lang=js&"
export * from "./example-day.vue?vue&type=script&lang=js&"
import style0 from "./example-day.vue?vue&type=style&index=0&id=350abec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350abec2",
  null
  
)

export default component.exports